module.exports = __webpack_public_path__ + "static/media/logo3.2d064e66.png";